import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 资产-模块
 */

var special = {
  path: '/assets',
  redirect: '/MyAssets',
  name: 'AssetsModel',
  component: BasicLayout,
  children: [{
    path: '/myAssets',
    // 我的NFR主页
    name: 'MyAssets',
    component: function component() {
      return import('views/assets/myAssets/Index');
    },
    meta: {
      keepAlive: true
    }
  }, {
    path: '/prizeTask',
    name: 'PrizeTask',
    component: function component() {
      return import('views/assets/prizeTask/Index');
    },
    meta: {
      title: '任务池'
    }
  }, {
    path: '/taskDetail/:id',
    name: 'TaskDetail',
    component: function component() {
      return import('views/assets/prizeTask/Detail');
    },
    meta: {
      title: '任务详情'
    }
  }, {
    path: 'syntheticPrizes/:setNo',
    name: 'SyntheticPrizes',
    component: function component() {
      return import('views/assets/prizeTask/SyntheticPrizes');
    },
    meta: {
      title: '合成奖励',
      keepAlive: true
    }
  }, {
    path: 'syntheticMaterials/:setNo',
    name: 'SyntheticMaterials',
    component: function component() {
      return import('views/assets/prizeTask/SyntheticMaterials');
    },
    meta: {
      title: '合成材料',
      keepAlive: true
    }
  }, {
    path: 'resale',
    name: 'Resale',
    component: function component() {
      return import('views/assets/Resale');
    },
    meta: {
      title: '转售' // keepAlive: true

    }
  }, {
    path: 'auth',
    name: 'Authentication',
    component: function component() {
      return import('views/assets/Authentication');
    },
    meta: {
      title: '身份验证'
    }
  }, {
    path: 'goldLoft',
    name: 'GoldLoft',
    component: function component() {
      return import('views/assets/goldLoft/index');
    },
    meta: {
      title: '炼金阁'
    }
  }, {
    path: 'goldTask',
    name: 'GoldTask',
    component: function component() {
      return import('views/assets/goldLoft/goldTask');
    },
    meta: {
      keepAlive: true,
      title: '炼金任务列表'
    }
  }, {
    path: 'goldTask/:id',
    name: 'GoldTaskDetail',
    component: function component() {
      return import('views/assets/goldLoft/goldTaskDetail');
    },
    meta: {
      title: '任务详情'
    }
  }, {
    path: 'inGoldRecord',
    name: 'InGoldRecord',
    component: function component() {
      return import('views/assets/goldLoft/inGoldRecord');
    },
    meta: {
      title: '炼金中'
    }
  }, {
    path: 'inAlchemist/:id',
    name: 'InAlchemist',
    component: function component() {
      return import('views/assets/goldLoft/inAlchemist');
    },
    meta: {
      title: '炼金详情'
    }
  }, {
    path: 'cancelAlchemy',
    name: 'CancelAlchemy',
    component: function component() {
      return import('views/assets/goldLoft/cancelAlchemy');
    },
    meta: {
      title: '取消炼金'
    }
  }, {
    path: 'selectAccRights',
    name: 'SelectAccRights',
    component: function component() {
      return import('views/assets/goldLoft/selectAccRights');
    },
    meta: {
      title: '选择加速权益'
    }
  }, {
    path: 'goldCompleteList',
    name: 'GoldCompleteList',
    component: function component() {
      return import('views/assets/goldLoft/goldCompleteList');
    },
    meta: {
      title: '已完成'
    }
  }, {
    path: 'goldSyntheticPrizes/:setNo',
    name: 'GoldSyntheticPrizes',
    component: function component() {
      return import('views/assets/goldLoft/goldSyntheticPrizes');
    },
    meta: {
      title: '炼金奖励',
      keepAlive: true
    }
  }, {
    path: 'goldSyntheticMaterials/:setNo',
    name: 'GoldSyntheticMaterials',
    component: function component() {
      return import('views/assets/goldLoft/goldSyntheticMaterials');
    },
    meta: {
      title: '炼金材料',
      keepAlive: true
    }
  }, {
    path: 'downloadWorks',
    name: 'DownloadWorks',
    component: function component() {
      return import('views/assets/myAssets/components/downloadWorks');
    },
    meta: {
      title: '下载作品'
    }
  }, {
    path: 'exchangeAddress',
    name: 'ExchangeAddress',
    component: function component() {
      return import('@/views/crowdfundingMall/mallCenter/addressManage');
    },
    meta: {
      title: '选择地址'
    }
  }, {
    path: 'batchResale',
    name: 'BatchResale',
    component: function component() {
      return import('views/assets/BatchResale');
    },
    meta: {
      title: '批量转售' // keepAlive: true

    }
  }, {
    path: 'transfer',
    name: 'Transfer',
    component: function component() {
      return import('views/assets/transfer/Transfer');
    },
    meta: {
      title: '藏品转移'
    }
  }, {
    path: 'transfer/list',
    name: 'TransferList',
    component: function component() {
      return import('views/assets/transfer/TransferList');
    },
    meta: {
      title: '藏品转移'
    }
  }, {
    path: 'giftNfr',
    name: 'GiftNfr',
    component: function component() {
      return import('@/views/assets/GiftNfr');
    },
    meta: {
      title: '选择转赠对象'
    }
  }, {
    path: 'giftNfrList',
    name: 'GiftNfrList',
    component: function component() {
      return import('@/views/assets/GiftNfrList');
    },
    meta: {
      title: '转赠'
    }
  }, {
    path: 'giftAuth',
    name: 'GiftAuth',
    component: function component() {
      return import('@/views/assets/GiftAuth');
    },
    meta: {
      title: '安全认证'
    }
  }, {
    path: 'shoppingCart',
    name: 'ShoppingCart',
    component: function component() {
      return import('@/views/assets/shoppingCart/cartList');
    },
    meta: {
      title: '购物车'
    }
  }]
};
export default special;